import React from 'react';
import './App.css';
import DotCounter from './components/DotCounter';
import Login from './components/Login';
import { AuthProvider, useAuth } from './contexts/AuthContext';

// Protected content component that only shows when authenticated
const ProtectedContent: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  
  // Show loading state
  if (isLoading) {
    return <div className="loading">Loading...</div>;
  }
  
  // If not authenticated, show login page
  if (!isAuthenticated) {
    return <Login />;
  }
  
  // If authenticated, show the app content
  return (
    <div className="App">
      <DotCounter />
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <ProtectedContent />
    </AuthProvider>
  );
}

export default App;
